import { RegulatoryBoard } from '@/shell/services/regulatory'

export function RegulatoryVendorPage() {
  return <RegulatoryBoard requestType="vendor" />
}
